module.exports = ['abrehamrahi.ir', 'hamrahi.cloud', 'sthamrahi.ir', 'zarebin.ir', 'browser-cdn.zarebin.ir', 'mmd-cdn.zarebin.ir', 'browser-cdn.zarebin.ir']